import React, { useEffect, useState } from 'react';

import Navbar from '../components/Navbar';
import '../App.css';
import Filters from '../components/Filters';
import { Pagination } from 'antd';
import { useSearchParams } from "react-router-dom"; // Import for URL parameters
import { Ticket } from 'lucide-react';

import { FetchService, services } from '../Functions';
import VoucherCard from '../components/VoucherCard';
import VoucherSkeleton from '../components/VoucherSkeleton';
import Loader from '../components/Loader';
import Footer from '../components/Footer';

import filtericon from '../assets/icons/filter.png'
import AOS from "aos";
import "aos/dist/aos.css";

AOS.init();

export default function Products() {



  const [searchParams] = useSearchParams(); // Get URL parameters

  const service = searchParams.get("service"); // Extract category from URL
  const search = searchParams.get("search"); // Extract category from URL


  const [currentPage, setCurrentPage] = useState(1)
  const [products, setProducts] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  const [loading, setLoading] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  const [productsUrl, setproductsUrl] = useState("");
  const [searchValue, setSearchValue] = useState("");
  const [FilterChange, setFilterChange] = useState(false);


  const fetchData = async () => {
    setLoading(true);
    try {
      console.log(`Fetching products for page ${currentPage}`);
      const data = await FetchService(service ? service : 4, currentPage);
      setProducts(data.Products || []);
      setTotalPages(data.TotalPages || 0);
    } catch (error) {
      console.error("Error fetching products:", error);
    } finally {
      setLoading(false);
    }
  };



  const handleFilterChange = async (filteredProducts) => {
    setFilterChange(true)
    setproductsUrl(filteredProducts);
    setLoading(true);

    try {
      const response = await fetch(filteredProducts);
      const data = await response.json();


      if (!data.Products) { // Fix length check

        console.log(getServiceIdByName(data.productType[0]))
        // const fetchedData = await FetchService(getServiceIdByName(data.Type), currentPage);
        // setProducts(fetchedData.Products || []);
        // setTotalPages(fetchedData.TotalPages || 0);
      } else {
        setProducts(data.Products || []);
        setTotalPages(data.TotalPages || 0);
        console.log(data);
      }
    } catch (error) {
      console.error("Error fetching products:", error);
    } finally {
      setLoading(false);
    }
  };



  async function CallSearch(text) {
    console.log(text)
    setLoading(true)
    setproductsUrl(`https://apiv2.mobileartsme.com/searchDTShop_Content?searchKey=${text}`)


    await fetch(`https://apiv2.mobileartsme.com/searchDTShop_Content?searchKey=${text}`)
      .then(res => res.json())
      .then(data => {
        setProducts(data.Products || [])
        setTotalPages(data.TotalPages || 0);
        setLoading(false)

      })

    console.log(productsUrl)

  }


  async function ChangePage(page) {
    window.scrollTo({ top: 0, behavior: 'smooth' }); // Scrolls smoothly to top

    setCurrentPage(page)
    setLoading(true)
  }




  useEffect(() => {
    if (!currentPage) return;

    setLoading(true);

    // If no URL and no search, use default fetch logic
    if (productsUrl === "" && !search) {
      fetchData();
    } else if ((search && currentPage === 1) && !FilterChange) {
      CallSearch(search);
    } else {
      // Paginated or searched fetch
      fetch(`${productsUrl}&page=${currentPage}`)
        .then(res => res.json())
        .then(data => {
          setProducts(data.Products || []);
          setTotalPages(data.TotalPages || 0);
        })
        .catch(error => console.error("Error fetching products:", error))
        .finally(() => setLoading(false));
    }
  }, [currentPage, search, productsUrl]); // 👈 this covers all relevant state changes



  function getServiceIdByName(serviceName) {
    const entry = Object.values(services).find(service => service.name.toLowerCase() === serviceName.toLowerCase());
    console.log(entry)
    return entry ? entry.id : null;
  }






   // Handle mobile detection
   useEffect(() => {
    const updateIsMobile = () => setIsMobile(window.innerWidth <= 1000);
    updateIsMobile(); // Run once on mount
    window.addEventListener("resize", updateIsMobile);

    // Cleanup on unmount
    return () => window.removeEventListener("resize", updateIsMobile);
  }, []); 


  return (
    <div>
      <Navbar />
      <div className='container pt-12'>
        <div className='row'>



          <div className='col-lg-3'>
            {!isMobile ? <Filters onFilterChange={handleFilterChange} /> : ""}

          </div>

          <div className='col-lg-8'>

            {isMobile ?
              <a class="btn mt-4" data-bs-toggle="offcanvas" href="#offcanvasExample" role="button" aria-controls="offcanvasExample">
                Filter Products
                <img src={filtericon} style={{ width: '12px', marginLeft: '10px' }} />
              </a>
              : ""}





            <div data-aos="fade-down" className="search-input-home mb-4 mt-2">

              <input className='bg_grey_light w-100 text-dark m-0' type="text" placeholder="Search for vouchers"
                style={{ paddingLeft: '35px', borderTopRightRadius: '0px', borderBottomRightRadius: '0px' }} onChange={(e) => setSearchValue(e.target.value)} />

              <button
                style={{ borderTopLeftRadius: '0px', borderBottomLeftRadius: '0px', fontSize: '1.3rem' }}
                className='btn bg_purple_light primary_purple bold' onClick={() => CallSearch(searchValue)}>Search</button>

            </div>




            <div className='vouchers_div'>

              {/* {products.length > 0 && loading ? (

                products.map((product, index) => (
                  product.prices.retail != null ? (
                    product ? <VoucherCard key={index} product={product} /> : null
                  ) : <h1>JJJJJ</h1>
                ))

              ) : (
                <>
                  {[...Array(6)].map((_, i) => (
                    <VoucherSkeleton key={i} />
                  ))}
                </>

              )} */}

              {loading ? (
                // If loading, show skeletons
                <>
                  {[...Array(6)].map((_, i) => (
                    <VoucherSkeleton key={i} />
                  ))}
                </>
              ) : products.length > 0 ? (
                // If not loading and have products, show products
                products.map((product, index) => (
                  product?.prices?.retail != null ? (
                    <VoucherCard key={index} product={product} />
                  ) : null
                ))
              ) : (
                // If not loading and no products
                <div className='d-flex flex-column align-items-center p-5 gap-4' style={{background:'#EFEBFF' , borderRadius:'10px'}} >
                      <Ticket size={50} color='#6D4EEC'/>
                      <h3>No Products</h3>
                      <p className='text-dark' >There are no products at this moment , try to refresh or try again later.</p>
                </div>
              )}

            </div>





            <div className='my-4 d-flex justify-content-end'>

              {!loading || products.length != 0 ? (
                <Pagination
                  current={currentPage}
                  total={totalPages * 10} // Assuming totalPages * 10 is the total items
                  onChange={(page) => ChangePage(page)}
                />
              ) : (
                ""
              )}


            </div>

          </div>

        </div>
      </div>

      {loading ? <Loader /> : ""}

      <div className="offcanvas offcanvas-start" tabindex="-1" id="offcanvasExample" aria-labelledby="offcanvasExampleLabel">
        <div className="offcanvas-header">
          <h2 className="offcanvas-title" id="offcanvasExampleLabel">Filters</h2>
          <button type="button" className="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
        </div>

        <div className="offcanvas-body">
          <Filters onFilterChange={handleFilterChange} />
        </div>

      </div>

      <Footer />
    </div>
  );
}
